import {ActionButton, IconButton, Stack, useTheme} from '@fluentui/react';
import React, {useEffect, useMemo, useState} from 'react';
import {useStore} from 'react-context-hook';
import {
	GlobalAnnouncementPopupState,
	GlobalAnnouncementState,
} from './GlobalAnnouncementPopup';
import {useGetMyGlobalAnnouncementsQuery} from './hooks/myGlobalAnnouncements.generated';
import {GlobalAnnouncement} from 'types';
import {useUserContext} from 'authentication/UserContext';
import {formatDateTime} from 'i18n/localeDateFormat';
import i18n from 'i18n/i18n';
import {useTranslation} from 'react-i18next';

const GlobalAnnouncementNavigation: React.FC = () => {
	const theme = useTheme();
	const {roles} = useUserContext();
	const [state, setState] = useStore<GlobalAnnouncementState>(
		'globalAnnouncementPopup',
	);

	const {t} = useTranslation('features/globalannouncements', {
		keyPrefix: 'GlobalAnnouncementNavigation',
	});

	const {data, loading, refetch} = useGetMyGlobalAnnouncementsQuery({
		variables: {
			myRoles: roles.map(r => r.toString()),
		},
		skip: roles?.length === 0,
	});

	const [announcementList, setAnnouncementList] = useState<
		GlobalAnnouncement[]
	>([]);

	useEffect(() => {
		if (!loading && data?.myGlobalAnnouncements) {
			setAnnouncementList(data.myGlobalAnnouncements);
			if (
				state?.initialPopupShown !== true &&
				data.myGlobalAnnouncements.length > 0
			) {
				setState({
					...state,
					popupState: GlobalAnnouncementPopupState.Open,
					announcement: data.myGlobalAnnouncements[0],
					initialPopupShown: true,
				});
			}
		}
	}, [data, loading]);

	useEffect(() => {
		if (state?.refetch) {
			refetch();

			setState({
				...state,
				refetch: false,
			});
		}
	}, [refetch, setState, state]);

	const header = (message: string) => {
		return {
			key: 'header-key',
			onRender() {
				return <div style={{fontWeight: 'bold', padding: 10}}>{message}</div>;
			},
		};
	};

	const dropDownAnnouncementListProps = useMemo(() => {
		if (announcementList.length === 0) {
			return {items: [header(t('NoMessages'))]};
		}

		return {
			items: [header(t('YourMessages'))].concat(
				announcementList.map(ga => {
					const nameShort =
						ga.name.length > 40 ? ga.name.substring(0, 40) + '...' : ga.name;
					return {
						key: ga.id,
						data: ga,
						onRender() {
							return (
								<ActionButton
									onClick={() =>
										setState({
											...state,
											popupState: GlobalAnnouncementPopupState.Open,
											announcement: ga,
										})
									}
									styles={{
										root: {width: '100%', paddingLeft: 10, paddingRight: 10},
									}}
								>
									<Stack
										horizontal
										tokens={{childrenGap: 10}}
										styles={{root: {width: '100%', textAlign: 'left'}}}
									>
										<Stack.Item grow>{`${nameShort}`}</Stack.Item>
									</Stack>
								</ActionButton>
							);
						},
					};
				}),
			),
		};
	}, [announcementList]);

	const counterStyle = {
		color: theme.palette.white,
		//marginLeft: '-80px',
	};

	return (
		<>
			<span style={counterStyle}>
				{loading
					? '(?)'
					: announcementList.length > 0
					? `(${announcementList.length})`
					: ''}
			</span>
			<IconButton
				title={'Announcement'}
				styles={{
					root: {
						color: theme.palette.white,
						backgroundColor: 'transparent !important',
					},
					rootExpanded: {
						color: theme.palette.white,
						backgroundColor: 'transparent !important',
					},
				}}
				menuProps={dropDownAnnouncementListProps}
				iconProps={{
					iconName: 'Ringer',
					styles: {
						root: {
							color: theme.palette.white,
						},
					},
				}}
			></IconButton>
		</>
	);
};

export default GlobalAnnouncementNavigation;
